import React from "react";
import Loader from "../../components/Loader";
import { AppointmentCard } from "./appointmentCard";

export default function CompletedTab({ visitationObject, access_token }: any) {
  if (visitationObject.isLoading) {
    return (
      <div className="h-[70vh] flex flex-row justify-center items-center w-full">
        <Loader />
      </div>
    );
  }

  if (visitationObject.error) {
    return <div>Error: {visitationObject.error.message}</div>;
  }

  const visitations = visitationObject.data?.visitations || [];

  return (
    <div className="md:fixed mt-3 flex justify-center">
      <div className="relative w-full h-[70vh] overflow-y-scroll">
        <div className="justify-start flex flex-col flex-wrap md:grid items-start grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full relative max-h-[95%] mb-3 md:mb-0 overflow-y-scroll pb-2">
          {visitations.length > 0 ? (
            visitations.map((visit: any) => (
              <AppointmentCard
                key={visit.visitationId}
                specialistName={visit.specialistName}
                appointmentName={visit.visitationName}
                appointmentCategoryTypeName={visit.visitTypeName}
                appointmentDate={new Date(visit.visitDate)}
                appointStartTimeName={new Date(visit.visitDate).toLocaleString('en-US', {
                  hour: 'numeric',
                  minute: 'numeric',
                  hour12: true
                })}
                branchName={visit.medicalServiceName}
                status={visit.medicalOutcomeName}
                appointmentId={visit.visitationId}
                accessToken={access_token}
                healthFacilityId="1"
                patientId={visit.patientId}
                onCancelClick={() => { }} // Empty function since completed visits can't be cancelled
              />
            ))
          ) : (
            <div className="flex w-full justify-center">
              <p className="text-red-500 text-base">
                No completed appointments available
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
